import { useWindowDimensions } from "react-native";

export default function useMdMediaQuery() {
  const { width } = useWindowDimensions();
  return width >= 640;
}
